import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "deleteButtonLayoutStyle", "wrap"];
import { GAP_TOKEN, ROW_GAP_TOKEN } from '../../constants/inlineLayout';
import EditorConditionActions from '../editor/EditorConditionActions';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineContainerWithEditorConditionActions = _ref => {
  let {
      children,
      deleteButtonLayoutStyle = 'end',
      wrap = true
    } = _ref,
    editorConditionActionProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (deleteButtonLayoutStyle === 'inline') {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexWrap: wrap ? 'wrap' : 'nowrap',
      columnGap: GAP_TOKEN,
      rowGap: ROW_GAP_TOKEN,
      children: [children, /*#__PURE__*/_jsx(Flex, {
        flexShrink: 0,
        children: /*#__PURE__*/_jsx(EditorConditionActions, Object.assign({}, editorConditionActionProps, {
          deleteIconStyle: "remove"
        }))
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    gap: GAP_TOKEN,
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      flexWrap: wrap ? 'wrap' : 'nowrap',
      columnGap: GAP_TOKEN,
      rowGap: ROW_GAP_TOKEN,
      children: children
    }), /*#__PURE__*/_jsx("div", {
      style: {
        flexShrink: 0
      },
      children: /*#__PURE__*/_jsx(EditorConditionActions, Object.assign({}, editorConditionActionProps))
    })]
  });
};
export default InlineContainerWithEditorConditionActions;